import React from 'react';
import { assetsPricing, pbPreferredPricing, } from '../../../../../../constants/PricingBenefits';
import { LazyImage } from '../../../../../shared/LazyImage';
import { clickCta } from '../../../../../../utils/analytics';
export var Img = function (_a) {
    var src = _a.src, classes = _a.classes, width = _a.width, height = _a.height;
    return (React.createElement("img", { src: src, alt: "img", width: width || 'auto', height: height || 'auto', className: "".concat(classes, " sui-max-w-none") }));
};
export var VideoPP = function (_a) {
    var noAutoPlay = _a.noAutoPlay;
    return (React.createElement("video", { width: "730", height: "auto", controls: true, autoPlay: !noAutoPlay },
        React.createElement("source", { src: pbPreferredPricing.pricingVideo['720p'], type: "video/mp4" })));
};
export var ModalCloseIcon = function (_a) {
    var setModal = _a.setModal;
    return (React.createElement("button", { type: "button", onClick: function () { return setModal(false); }, "data-testid": "modalClose" },
        React.createElement("img", { alt: "img", src: assetsPricing.CloseIcon, width: "auto", height: "auto" })));
};
export var VideoLabelBtn = function (_a) {
    var rounded = _a.rounded;
    return (React.createElement(Img, { src: assetsPricing.videoPreferredPricingWithButton, classes: "sui-w-full sui-h-full ".concat(rounded ? 'sui-rounded-md' : '') }));
};
export var VideoLabelPlayBtn = function (_a) {
    var rounded = _a.rounded, isDark = _a.isDark, setModal = _a.setModal;
    return (React.createElement("div", { className: "sui-relative sui-mx-auto", style: { maxWidth: '300px' } },
        React.createElement("div", { className: "" },
            React.createElement(LazyImage, { src: assetsPricing.proXtraPreferredD, classes: "".concat(rounded ? 'sui-rounded-md' : ''), altText: "Top banner, Home Depot store", "aria-label": "image" })),
        React.createElement("div", { className: "sui-absolute sui-top-0 sui-right-0 sui-left-0 sui-bottom-0 sui-flex sui-justify-center" },
            React.createElement("button", { type: "button", onClick: function () {
                    setModal(true);
                    clickCta('pricing benefits: preferred pricing: hdiw overlay: video view');
                } },
                React.createElement(LazyImage, { src: assetsPricing[isDark ? 'iconVideoPlayDark' : 'VideoLogowhite'], classes: "sui-h-full ".concat(isDark ? 'sui-opacity-75' : ''), width: "76", height: "76", "aria-label": "image", altText: "Top banner, Home Depot store" })))));
};
export var VideoContainer = function (_a) {
    var setModal = _a.setModal, noAutoPlay = _a.noAutoPlay;
    return (React.createElement("div", { className: "sui-bg-inverse sui-h-full sui-px-4 sui-pb-4 sui-pt-1 sui-flex sui-justify-center sui-flex-col" },
        React.createElement("div", { className: "sui-absolute sui-right-3 sui-top-3" },
            React.createElement(ModalCloseIcon, { setModal: setModal })),
        React.createElement("div", { className: "sui-pt-3" },
            React.createElement(VideoPP, { noAutoPlay: noAutoPlay }))));
};
